import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md q-gutter-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Please add new spare part", -1 /* HOISTED */)
const _hoisted_3 = { class: "q-mt-md q-mb-xs column full-width" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "* Material Number", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.getDisplayAddSparePartDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getDisplayAddSparePartDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "q-pa-md",
          style: {"width":"450px","overflow":"auto","overflow-x":"hidden"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_form, {
              class: "q-gutter-md",
              onSubmit: _ctx.onConfirm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center q-mt-none" }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_q_space),
                    _withDirectives(_createVNode(_component_q_btn, {
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose()))
                    }, null, 512 /* NEED_PATCH */), [
                      [_directive_close_popup]
                    ]),
                    _createElementVNode("label", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_q_input, {
                        modelValue: _ctx.materialNumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.materialNumber) = $event)),
                        class: "full-width",
                        required: "",
                        outlined: "",
                        dense: "",
                        onKeypress: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isNumberCheck($event)))
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_q_card_actions, {
                  align: "right",
                  class: "q-mt-none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      label: "Add",
                      class: "action-button",
                      type: "submit"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onSubmit"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}